import { Divider } from 'antd';
import colors from '../../styles/Color.scss';

const MyDividerDiffColor = ({ smaller = true, ...otherProps }) => {
  return (
    <Divider
      {...otherProps}
      style={{ borderColor: colors.menuBorder }}
      className={`${smaller ? 'divider_small' : ''}`}
    />
  );
};

export default MyDividerDiffColor;
